module.exports = __webpack_public_path__ + "static/media/chevron-up.c45bef8f.svg";